import type { FormikContextType } from 'formik';
import { useFormik } from 'formik';
import _ from 'lodash';
import * as Yup from 'yup';
import { Alert, Store } from '../../store';

interface Values {
  email: string;
}

interface Form {
  formik: FormikContextType<Values>;
  loading: boolean;
  alert: Alert;
}

const validationSchema = Yup.object({
  email: Yup.string()
    .trim()
    .required('Please enter a valid email address.')
    .email('Please enter a valid email address.')
});

export const useForm = (): Form => {
  const [forgotPassword, { loading, error }] = Store.User.useForgotPassword();
  const alert = Alert.useAlert(error);

  const formik = useFormik<Values>({
    initialValues: { email: '' },

    validationSchema,
    validateOnMount: true,

    validate(): void {
      alert.hide();
    },

    onSubmit(data: Values): void {
      alert.hide();

      if (!loading) {
        // Execute the mutation
        forgotPassword(data);
      }
    }
  });

  return {
    formik,
    loading,
    alert
  };
};
